import { useState, useRef, useEffect, useContext } from "react";
import { SwalAlertClass } from "core/swalClass";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axiApi from "ApiCaller";
import ImageChooser from "components/ImageChooser";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AuthContext from "context/AuthContext";
import MapManagerModal from "components/maps/MapManagerModal";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import {defaultRequires, requiresFields} from "./labelsDefault";

const FormPanel = ({ showCanvas, setShowCanvas, item, update }) => {
    const { user, azureMapsKey } = useContext(AuthContext);
    const [formData, setFormData] = useState(item);
    const [showMapModal, setShowMapModal] = useState(false);
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const handleModalMap = () => {
        setShowMapModal(true);
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        let form = e.target.closest("form");
        let data = new FormData(form);
        axiApi
            .post("/api/panel/", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((r) => {
                if (r.data.status) {
                    update(r.data.item, data.get("idx"));
                    setShowCanvas(false);
                    Alert.success("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.warning("Error", r.data.message);
                }
            })
            .catch((error) => {
                console.error(error);
                Alert.error("Error en ell seervidor", "Informar al administrador");
            });
    };

    const handleClose = () => {
        setShowCanvas(false);
    };

    useEffect(() => {
        setFormData(item);
    }, [item]);

    useEffect(() => {
        const handlePositionSelected = (e) => {
            const { lat, lng } = e.detail;
            setFormData((prev) => ({
                ...prev,
                lat: lat.toFixed(6),
                lng: lng.toFixed(6),
            }));
        };

        subscribeEvent("mapmodal:position:selected", handlePositionSelected);

        return () => {
            unsubscribeEvent("mapmodal:position:selected", handlePositionSelected);
        };
    }, []);

    return (
        <Offcanvas
            show={showCanvas}
            onHide={handleClose}
            placement="end"
            backdrop="false"
            scroll={true}
            style={{ width: "40%" }}>
            <Offcanvas.Header className="preview-canvas" closeButton>
                <div className="preview-icon">
                    <FontAwesomeIcon icon="tree-city" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>
                        <small>Municipio</small>
                        <div>{item.name}</div>
                    </Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="container-fluid">
                    <Form
                        className="row pb-5"
                        onSubmit={onSubmit}
                        encType="multipart/form-data">
                        <input type="hidden" name="token" value={item.token} />
                        <input type="hidden" name="idx" value={item.idx} />
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <ImageChooser
                                        name={"ilogo-" + item.token}
                                        image={
                                            item.ilogo ? "/media/" + item.ilogo : null
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Nombre:</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        required
                                        defaultValue={item.name}
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Descripción:</label>
                                </div>
                                <div className="col-md-9">
                                    <textarea
                                        className="form-control"
                                        id="description"
                                        name="description"
                                        defaultValue={item.description}
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Dirección:</label>
                                </div>
                                <div className="col-md-9">
                                    <textarea
                                        className="form-control"
                                        id="full_address"
                                        name="full_address"
                                        defaultValue={item.full_address}
                                    />
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Coordenadas:</label>
                                </div>
                                <div className="col-md-9 card pb-3">
                                    <div className="row">
                                        <div className="mt-2 col-5">
                                            <label htmlFor="lat" className="form-label">
                                                Latitud
                                            </label>
                                            <input
                                                type="number"
                                                max="90"
                                                min="-90"
                                                className="form-control"
                                                id="lat"
                                                name="lat"
                                                step="any"
                                                value={formData.lat}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="mt-2 col-5">
                                            <label htmlFor="lng" className="form-label">
                                                Longitud
                                            </label>
                                            <input
                                                type="number"
                                                max="90"
                                                min="-90"
                                                step="any"
                                                className="form-control"
                                                id="lng"
                                                name="lng"
                                                value={formData.lng}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="mt-3 pt-4 col-2">
                                            <Button
                                                title="Editar ubicación"
                                                variant="btn btn-outline-primary"
                                                type="button"
                                                onClick={handleModalMap}>
                                                <FontAwesomeIcon icon="fa-map-location-dot" />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Mapa:</label>
                                </div>
                                <div className="col-md-9">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <select
                                                className="form-select"
                                                name="map_type"
                                                defaultValue={item.map_type || 'lf'}
                                            >
                                                <option value="lf">Leaflet (Default)</option>
                                                <option value="az">Azure Maps</option>
                                            </select>
                                        </div>
                                        <div className="col-md-8">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="azure_maps_key"
                                                placeholder="Azure Maps API Key"
                                                defaultValue={item.azure_maps_key}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-1">
                                        <div className="offset-md-4 col-md-8">
                                            <small className="text-muted">Si se deja vacío, se usará la clave global.</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Distancia:</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="number"
                                        className="form-control text-end d-inline-block"
                                        id="distance"
                                        name="distance"
                                        required
                                        defaultValue={item.distance}
                                        style={{ width: "90px" }}
                                    />
                                    <span className="text-muted ms-2">metros</span>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Descarga contenedor:</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="number"
                                        className="form-control text-end d-inline-block"
                                        id="unloading"
                                        name="unloading"
                                        required
                                        defaultValue={item.unloading}
                                        style={{ width: "90px" }}
                                    />
                                    <span className="text-muted ms-2">minutos</span>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Requisitos ruta:</label>
                                </div>
                                <div className="col-md-9">
                                    {requiresFields.map(({ key, label }) => (
                                        <div
                                            className="d-flex align-items-center justify-content-between px-3 py-2 mb-2"
                                            key={key}>
                                            <label className="mb-0">{label}</label>
                                            {(formData.requires || {})[key] ? (
                                                <FontAwesomeIcon
                                                    icon="check"
                                                    className="text-primary"
                                                    size="lg"
                                                />
                                            ) : (
                                                <span className="text-secondary">
                                                    <FontAwesomeIcon icon="minus" size="lg" />
                                                </span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex align-items-center justify-content-end">
                                    <label>Proyecto:</label>
                                </div>
                                <div className="col-md-9">{item.project}</div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex justify-content-end">
                                    <label>Modelos:</label>
                                </div>
                                <div className="col-md-9">
                                    {item.sensors.map((sensor, idx) => (
                                        <p className="m-1" key={idx}>
                                            {sensor}
                                        </p>
                                    ))}
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-3 d-flex justify-content-end">
                                    <label>Usuarios:</label>
                                </div>
                                <div className="col-md-9">
                                    {item.users.map((email, idx) => (
                                        <p className="m-1" key={idx}>
                                            {email}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="text-end pb-3 col-12 fixed-bottom">
                            <button
                                type="button"
                                className="btn btn-secondary me-4"
                                onClick={handleClose}>
                                Cancelar
                            </button>
                            {/* <button type="button" className="btn btn-primary" onClick={onSubmit}>Guardar</button> */}
                            {user.is_superuser ? (
                                <button type="submit" className="btn btn-primary">
                                    Guardar
                                </button>
                            ) : (
                                <></>
                            )}
                        </div>
                    </Form>
                </div>
            </Offcanvas.Body>
            <MapManagerModal
                provider={item.map_type}
                show={showMapModal}
                setShow={setShowMapModal}
                title={"Panel"}
                initialLat={formData.lat}
                initialLng={formData.lng}
            />
        </Offcanvas>
    );
};

export default FormPanel;
